import { Observable } from 'rxjs';

import { Response } from '@shure/shared/angular/data-access/system-api/models';

import { AutomaticGainControlChannel } from '../models';

export abstract class AutomaticGainControlApiService {
	/**
	 * Get channel which supports agc.
	 */
	public abstract getChannel$(channelId: string): Observable<AutomaticGainControlChannel>;

	/**
	 * Enable/disable agc for channel.
	 */
	public abstract toggleAgc(channelId: string, enabled: boolean): Observable<Response<void, string>>;

	/**
	 * Set target level for agc channel.
	 */
	public abstract setTargetLevel(channelId: string, targetLevel: number): Observable<Response<void, string>>;

	/**
	 * Set max boost for agc channel.
	 */
	public abstract setMaxBoost(channelId: string, maxBoost: number): Observable<Response<void, string>>;
	/**
	 * Set max cut for agc chanenl.
	 */
	public abstract setMaxCut(channelId: string, maxCut: number): Observable<Response<void, string>>;
}
